module.exports = __webpack_public_path__ + "media/12_32.aa1d4efe.wav";